import React, { Component } from 'react';

class Checkbox extends Component {
  requestChange(val) {
    this.props.linker.value=val;
    // this.props.valueLink.requestChange(val);
  }
  render() {
    return (
      <label><input type="checkbox" checked={this.props.linker.value===this.props.value} onChange={(e)=>{ if(e.target.checked) { this.requestChange(this.props.value); } else { this.requestChange(''); } }}/><span></span></label>
    );

    /*
    return (
      <span className="select w100">
        <select className="w100" value={this.getValue()} onChange={(e)=>{ this.requestChange(e.target.value) }}>
          <option value=""></option>
          <option value="1">Да</option>
          <option value="system:checkbox_no">Нет</option>
        </select>
      </span>
    )
    */
  }
}

export default Checkbox;